import React from 'react'
import { lower } from 'change-case'
import { connect } from 'react-redux'
import { getFormValues, Field, change } from 'redux-form'
import { CircularProgress } from '@material-ui/core'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { FileUploadCell } from 'components'
import { getCategory, getSubCategory } from '../../helper'

import { AttachmentFormContainer } from './styled'
import r from 'reactotron-react-js'

const FieldAttachment = props => {
  const { 
    valueForm,
    attachmentType, 
    loading, 
  } = props

  const { special, isAdditional } = valueForm
  var documentTypes = attachmentType ? attachmentType.documentTypes ? [...attachmentType.documentTypes] : [] : []
  
  if (isAdditional && attachmentType && attachmentType.additionalDocumentTypes.length !== 0) {
    documentTypes = attachmentType.additionalDocumentTypes
  }

  if (special) {
    if (documentTypes.length > 0) {
      const index = documentTypes.findIndex(dt => dt.code === 'PR07')
      if (index !== -1) {
        documentTypes[index].isRequire = true
      } else {
        documentTypes.push({ name: 'Quotation/Invoice', code: 'PR07', isRequire: true })
      }
    } else {
      documentTypes.push({ name: 'Quotation/Invoice', code: 'PR07', isRequire: true })
    }
  }

  documentTypes = documentTypes.sort((a, b) => (a.isRequire === b.isRequire)? 0 : !a.isRequire? 1 : -1)
  documentTypes = [...documentTypes,{code:'pr15',name:'Others',isRequire:false,}]
  var countAttachLine = Array(Math.ceil(documentTypes.length/3)).fill(1)

  return (
    <React.Fragment>
      { loading ? 
        <CircularProgress color='primary' /> : 
        <React.Fragment>
          {countAttachLine.map((v,i1)=>{
            return (<AttachmentFormContainer key={i1}>
              {documentTypes.map((dt,i2) =>{   
                if((Math.floor(i2/3))===i1){
                  return (
                    <div className='fileUploadContainer' key={i2}>
                      <Field change={change} docCode={lower(dt.code)} name={lower(dt.code)} label={dt.name} require={dt.isRequire} type={type.file} component={FieldInput} containerStyle={{marginRight:0}} oldFiles={valueForm.attachments}/>
                      <div style={{flex:1}}>
                        {valueForm.attachments.filter(x=>(x.documentTypeCode.toLowerCase() === dt.code.toLowerCase())&&(!x.deleted)).map((item,i3)=>(
                          <FileUploadCell
                            key={`${item.originalFilename}${i3}`}
                            fileName={item.originalFilename}
                            fileSize={item.size}
                            deleted={item.deleted}
                            urlPath={item.urlPath}
                            onClickDelete={() => {
                              let index = valueForm.attachments.findIndex(x=>x.id===item.id)
                              props.dispatch(change('formEditPR',`attachments[${index}].deleted`,true))
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  )
                } else{
                  return null
                }
              })}
            </AttachmentFormContainer>)
          })}
        </React.Fragment>
      }
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const valueForm = getFormValues('formEditPR')(state)
  const menus = state.pr.menus || []
  var category = {}
  var subCategory = {}

  if (valueForm) {
    if (valueForm.menuCategory) {
      category = getCategory(menus)(valueForm.menuCategory)
    }
    if (valueForm.menuSubCategory && category&&category.subCategories) {
      subCategory = getSubCategory(category.subCategories)(valueForm.menuSubCategory)
    }
  }

  var attachType = ''
  if (valueForm.companyCode) {
    if (subCategory.attachmentType) {
      attachType = subCategory.attachmentType
    } else {
      if (subCategory.attachmentTypes) {
        if (subCategory.attachmentTypes[valueForm.companyCode]) {
          attachType = subCategory.attachmentTypes[valueForm.companyCode]
        } else if (subCategory.attachmentTypes['all']) {
          attachType = subCategory.attachmentTypes['all']
        }
      }
    }
  }

  const attachmentTypes = state.pr.attachmentTypes
  let attachmentTypeTemp = attachmentTypes.find(a => a.code === attachType)
  const attachmentType =  JSON.parse(JSON.stringify(attachmentTypeTemp||null))

  return ({
    attachmentTypes,
    attachmentType,
    loading: state.pr.attachmentTypeLoading,
    initialValues: {
      ...valueForm,
    },
    valueForm,
  })
}

const mapDispatchToProps = (dispatch) =>({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(FieldAttachment)
